import * as dom from './dom';
import * as state from '../core/state';
import { generateKeyPair } from '../core/crypto';

function saveProfile() {
    const newName = dom.nameInput.value.trim();
    if (newName) {
        state.setUserName(newName);
        generateKeyPair();
        console.log(`User name set to: ${state.userName}`);

        if (state.userPublicKey && state.userFingerprint) {
            dom.yourFingerprintDisplay.textContent = state.userFingerprint;
            dom.currentTopicDisplay.textContent = state.userFingerprint || 'None';
        }
        dom.profileModal.style.display = 'none';
    }
}

export function initModal() {
    dom.saveProfileButton.addEventListener('click', saveProfile);

    dom.profileButton.addEventListener('click', () => {
        dom.profileModal.style.display = 'block';
        dom.nameInput.value = state.userName;
        dom.yourFingerprintDisplay.textContent = state.userFingerprint || 'None';
    });

    dom.closeProfileModal.addEventListener('click', () => {
        dom.profileModal.style.display = 'none';
    });

    window.addEventListener('click', (event) => {
        if (event.target === dom.profileModal) {
            dom.profileModal.style.display = 'none';
        }
    });

    window.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && dom.profileModal.style.display === 'block') {
            dom.profileModal.style.display = 'none';
        }
    });
}
